import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var alertStyle = function alertStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary1 = _getThemeData.primary1,
    primary3 = _getThemeData.primary3,
    primary6 = _getThemeData.primary6;
  return css(["body{a,a:hover{color:", ";}}.ant-alert.ant-alert{&.ant-alert-info{background:", ";border-color:", ";.ant-alert-icon{color:", ";}}}"], primary6, primary1, primary3, primary6);
};
export default alertStyle;